import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getAudios = createAsyncThunk("audios/get", async (payload) => {
  try {
    const response = await magnifiAPI.getAudios(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteAudio = createAsyncThunk("audios/deleteAudio", async (payload) => {
  try {
    const response = await magnifiAPI.deleteAudio(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const uploadAudio = createAsyncThunk("audios/uploadAudio", async (payload) => {
  try {
    const response = await magnifiAPI.uploadAudio(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAudioDetails = createAsyncThunk("audios/getAudioDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getAudioDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
